{
  "name": "TokenPriceOracle",
  "abi": [
    {
      "inputs": [],
      "name": "MAX_DELAY",
      "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "WEI_IN_ETH",
      "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "aggregatorOrToken",
          "type": "address"
        },
        { "internalType": "uint256", "name": "ethAmount", "type": "uint256" },
        { "internalType": "uint8", "name": "tokenDecimals", "type": "uint8" }
      ],
      "name": "getTokenValueOfEth",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "tokenValueOfEth",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "oracleValidUntil",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    }
  ],
  "addresses": {
    "1": "0x302275dcF9919c5449F2d53253ACD06315385272",
    "5": "0x302275dcF9919c5449F2d53253ACD06315385272",
    "10": "0x302275dcF9919c5449F2d53253ACD06315385272",
    "137": "0x302275dcF9919c5449F2d53253ACD06315385272",
    "8453": "0x302275dcF9919c5449F2d53253ACD06315385272",
    "36865": "0x302275dcF9919c5449F2d53253ACD06315385272",
    "42161": "0x302275dcF9919c5449F2d53253ACD06315385272",
    "421614": "0x33CE83528023d9aee4e6321250514741F00976DB",
    "5000": "0x46B1Aee819Af33fa9617059A3D54e5352793473B",
    "534352": "0x3053451A384524C57dAF9420f8d8b8464555E1e8"
  }
}
